/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.object.assign";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/artifacts/APP/AppSwitchPowerActivityH5/AppSwitchPowerActivityH5_DEV_group1_dev_20200310201907/node_modules/@babel/runtime/helpers/builtin/es6/asyncToGenerator";
import _classCallCheck from "/artifacts/APP/AppSwitchPowerActivityH5/AppSwitchPowerActivityH5_DEV_group1_dev_20200310201907/node_modules/@babel/runtime/helpers/builtin/es6/classCallCheck";
import _createClass from "/artifacts/APP/AppSwitchPowerActivityH5/AppSwitchPowerActivityH5_DEV_group1_dev_20200310201907/node_modules/@babel/runtime/helpers/builtin/es6/createClass";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
import UBT, { UBTTypeCount, UBTTypeError, LogLevel, performanceAnalysis } from '@hb/ubt-js/lib/h5';
import config from '../const/config';
import env from '../utils/env';
UBT.config({
  apiAddress: config.UBT_API,
  gzip: false
});
var platform = 'H5';

if (env.isEasyBikeApp) {
  platform = env.platform.os;
} else if (env.isAlipayBrowser) {
  platform = 'Alipay';
} else if (env.isAliMPMonitor || env.isAliMP) {
  platform = 'Alipay_mini';
}

var defaultUBT = UBT.bindData({
  ubtType: UBTTypeCount,
  useragent: navigator.userAgent,
  appname: 'h5_HP',
  appversion: env.appVersion,
  platformAPP: env.platform.app,
  $platform: platform,
  $utm_source: 'H5',
  $appType: '哈啰换电',
  categoryId: '哈啰换电',
  $screen_height: window.screen.height,
  $screen_width: window.screen.width,
  network: navigator.connection && navigator.connection.type,
  codeEnv: process.env.NODE_ENV,

  get $url() {
    return window.location.href;
  }

});
var errorUBT = defaultUBT.bindData({
  ubtType: UBTTypeError
}).setLogLevel(LogLevel.ERROR);
performanceAnalysis(defaultUBT, 'h5_HP');

var UBTHelper =
/*#__PURE__*/
function () {
  function UBTHelper() {
    _classCallCheck(this, UBTHelper);
  }

  _createClass(UBTHelper, null, [{
    key: "bindData",

    /**
     * 绑定数据, 之后的任何一次send都会发送绑定的数据
     * @param args eg. { p1: 1 }, { p2: 2 }
     *  keyword需要指定
     *  ubtType 默认值UBTTypeCount
     */
    value: function bindData() {
      var _defaultUBT, _errorUBT;

      defaultUBT = (_defaultUBT = defaultUBT).bindData.apply(_defaultUBT, arguments);
      errorUBT = (_errorUBT = errorUBT).bindData.apply(_errorUBT, arguments);
    }
  }, {
    key: "send",
    value: function () {
      var _send = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _defaultUBT2;

        var _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                (_defaultUBT2 = defaultUBT).send.apply(_defaultUBT2, _args);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function send() {
        return _send.apply(this, arguments);
      };
    }()
  }, {
    key: "sendError",
    value: function () {
      var _sendError = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(error) {
        var ubtParams;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                ubtParams = {};

                if (!(error instanceof Error)) {
                  _context2.next = 5;
                  break;
                }

                Object.assign(ubtParams, {
                  keyword: error.name,
                  message: JSON.stringify({
                    stack: error.stack,
                    message: error.message
                  }),
                  errordata: JSON.stringify(error)
                });
                _context2.next = 6;
                break;

              case 5:
                return _context2.abrupt("return");

              case 6:
                try {
                  errorUBT.send(ubtParams);
                } catch (e) {// console.log(e);
                }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      return function sendError(_x) {
        return _sendError.apply(this, arguments);
      };
    }()
  }, {
    key: "pageView",
    value: function pageView() {
      try {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        args[0].keyword = 'pageview';
        this.send.apply(this, args);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
      }
    }
  }, {
    key: "clickButton",
    value: function clickButton() {
      try {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        args[0].keyword = 'clickButton';
        this.send.apply(this, args);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
      }
    }
    /**
    * 支付埋点
    * 参数 {payAmount:金额，adSource：运营渠道，payWay：支付宝，微信，余额等，payStatus:0成功 1失败}
    * */

  }, {
    key: "payment",
    value: function payment() {
      try {
        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        args[0].keyword = 'payment';
        this.send.apply(this, args);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
      }
    }
  }, {
    key: "bindUserInfo",
    value: function bindUserInfo(userInfo) {
      UBTHelper.bindData(userInfo);
    }
  }]);

  return UBTHelper;
}();

export { UBTHelper as default };